import React, { createContext, useContext, useState } from "react";

interface DashboardSideBarContextType {
  isOpen: boolean;
  toggleSideBar: () => void;
  setIsOpen: (isOpen: boolean) => void;
}

const DashboardSideBarContext = createContext<
  DashboardSideBarContextType | undefined
>(undefined);

export const DashboardSideBarProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleSideBar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <DashboardSideBarContext.Provider
      value={{ isOpen, toggleSideBar, setIsOpen }}
    >
      {children}
    </DashboardSideBarContext.Provider>
  );
};

export const useDashboardSideBar = () => {
  const context = useContext(DashboardSideBarContext);
  if (!context) {
    throw new Error(
      "useDashboardSideBar must be used inside DashboardSideBarProvider"
    );
  }
  return context;
};
